import {Fragment, useContext, useEffect, useState} from "react";
import {Form, Spinner} from "react-bootstrap";
import {ReactComponent as DeleteIconDark} from "../../asset/icons/deleteIconDark.svg";
import {ReactComponent as EditIonDark} from "../../asset/icons/editIconDark.svg";
import {GlobalStateContext} from "../../layouts/GlobalStates";
import {del, get, post, put} from "../../controlers/global/ConfigRequest";
import Select from "react-select";
import {
  GET_AUTOMATION_GROUP_LIST,
  GET_AUTOMATION_GROUPS,
  GET_COMPANY_RULES_TREE,
  GET_USER_OF_COMPANY,
} from "../../helperData/ApiAddress";
import {ToastContext} from "../../component/global/ToastContext";
import ConfirmModal from "./ConfirmModal";
import {useTranslation} from "react-i18next";
import {MagicStar} from "iconsax-react";
import AIHandlingGroupModal from "../exp-settings/components/handling-groups/AIHandlingGroupModal";
import { AiCoinHint } from "../../features/ai-billing/AiCoinGate";
import "../exp-settings/components/handling-groups/ai-handling-styles.scss";

export default function SuperViserGroup({active, form}) {
  const show = useContext(ToastContext);
  const [userTree, setUserTree] = useState([]);
  const [automationGroups, setAutomationGroups] = useState([]);
  const [automationGroupList, setAutomationGroupList] = useState([]);
  const [companyRulesTree, setCompanyRulesTree] = useState({
    name: "",
    id: 0,
    toggled: true,
    className: "zeroLevel",
    children: [],
  });
  const [loading, setLoading] = useState(false);
  const [listLoader, setListLoader] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [createLoader, setCreateLoader] = useState(false);
  const [aiModalShow, setAiModalShow] = useState(false);

  const [groupTitle, setGroupTitle] = useState("");
  const [groupTitleErr, setGroupTitleErr] = useState("");
  const [groupHead, setGroupHead] = useState(null);
  const [groupHeadErr, setGroupHeadErr] = useState("");
  const [groupLimit, setGroupLimit] = useState([]);
  const [groupLimitErr, setGroupLimitErr] = useState("");
  const [groupMembers, setGroupMembers] = useState([]);
  const [groupMembersErr, setGroupMembersErr] = useState("");
  const [editMode, setEditMode] = useState(false);
  const {auth, setAuth} = useContext(GlobalStateContext);
  const {t} = useTranslation();

  const getCompanyId = () => form?.id || auth.usercompany;

  const getUserTree = (companyId) => {
    if (!companyId) return;
    get(GET_USER_OF_COMPANY.replace("{id}/", companyId)).then(
      (r) => {
        setUserTree(
          r.map((item) => ({
            value: item.id,
            label:
              `${item.first_name || ""} ${item.last_name || ""}`.trim() +
              (item.role ? ` (${item.role})` : "") +
              (item.phone_number ? ` — ${item.phone_number}` : ""),
          }))
        );
      }
    );
  };

  const getAutomationGroupList = (companyId) => {
    if (!companyId) return;
    get(GET_AUTOMATION_GROUP_LIST.replace("{id}/", companyId)).then(
      (r) => {
        setAutomationGroupList(
          r.map((item) => ({value: item.id, label: item.name}))
        );
      }
    );
  };

  const getAutomationGroups = (loader) => {
    loader && setListLoader(true);
    get(GET_AUTOMATION_GROUPS.replace("{id}/", ""))
      .then((r) => {
        setAutomationGroups(r);
      })
      .finally((e) => {
        setListLoader(false);
      });
  };

  const deleteAutomationGroup = (id) => {
    setDeleteLoader(id);
    del(GET_AUTOMATION_GROUPS.replace("{id}/", id + "/"))
      .then((r) => {
        getAutomationGroups(false);
      })
      .catch((e) => {
        show(t("Src.Pages.Profile.SuperViserGroup.Danger"), "danger");
      })
      .finally((e) => {
        setDeleteLoader(false);
      });
  };

  const createAutomationGroup = () => {
    let hasErr = false;
    setGroupTitleErr("");
    setGroupHeadErr("");
    setGroupLimitErr("");
    setGroupMembersErr("");

    if (groupTitle === "") {
      setGroupTitleErr(
        t("Src.Pages.Profile.SuperViserGroup.setGroupTitleErr")
      );
      hasErr = true;
    }
    if (!groupHead) {
      setGroupHeadErr(
        t("Src.Pages.Profile.SuperViserGroup.setGroupHeadErr")
      );
      hasErr = true;
    }
    if (!groupMembers?.length) {
      setGroupMembersErr(
        t("Src.Pages.Profile.SuperViserGroup.setGroupMembersErr")
      );
      hasErr = true;
    }

    if (hasErr) {
      return false;
    }
    setCreateLoader(true);

    let request;

    if (editMode) {
      request = put;
    } else {
      request = post;
    }

    let replacement = editMode ? editMode + "/" : "";

    request(GET_AUTOMATION_GROUPS.replace("{id}/", replacement), {
      name: groupTitle,
      company: getCompanyId(),
      members: groupMembers.map((member) => member.value),
      assign_groups: groupLimit?.map((group) => group.value) || [],
      head: groupHead.value,
    })
      .then((r) => {
        getAutomationGroups(false);
        resetForm();
      })
      .catch((e) => {
        let errObj = e.response.data;
        if ("name" in errObj) {
          setGroupTitleErr(
            t("Src.Pages.Profile.SuperViserGroup.setGroupTitleErr2")
          );
        }
        if (errObj.message === "Head must be member of group") {
          setGroupHeadErr(
            t("Src.Pages.Profile.SuperViserGroup.setGroupHeadErr2")
          );
        }
      })
      .finally((e) => {
        setCreateLoader(false);
      });
  };

  const resetForm = () => {
    setGroupTitle("");
    setGroupHead(null);
    setGroupLimit([]);
    setGroupMembers([]);
    setEditMode(false);
  };
  const getCompanyRules = (companyId) => {
    if (!companyId) return;
    setLoading(true);
    get(GET_COMPANY_RULES_TREE.replace("{id}/", companyId)).then(
      (r) => {
        setCompanyRulesTree({
          name: "",
          id: 0,
          toggled: true,
          className: "zeroLevel",
          children: r,
        });
        setLoading(false);
      }
    );
  };

  const [itemTypeTreeSelected, setItemTypeTreeSelected] = useState();

  const itemTypeSelectHandle = (e, a, item) => {
    setItemTypeTreeSelected(item);
  };

  useEffect(() => {
    const companyId = getCompanyId();
    if (!companyId) return;
    getUserTree(companyId);
    getCompanyRules(companyId);
    getAutomationGroups(true);
    getAutomationGroupList(companyId);
  }, [form?.id, auth.usercompany]);

  const goToEditMode = (item) => {
    setEditMode(item.id);
    setGroupTitle(item.name);
    setGroupHead({
      label: item.head.first_name + " " + item.head.last_name,
      value: item.head.id,
    });
    setGroupLimit(
      item.assign_groups.map((item) => ({
        label: item.name,
        value: item.id,
      }))
    );
    setGroupMembers(
      item.members.map((item) => ({
        label: item.first_name + " " + item.last_name,
        value: item.id,
      }))
    );
  };

  const [modalShow, setModalShow] = useState(false);

  return (
    <div className="page-load-fade">
      <form
        className="general-info-form"
        onSubmit={(e) => e.preventDefault()}
      >
        <Form.Group controlId="gtitle">
          <Form.Label>
            {t("Organizational.Profile.GroupTitle.Place.Holder")}
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="مثال : نیما"
            value={groupTitle}
            onChange={(e) => setGroupTitle(e.target.value)}
          />
          {groupTitleErr && (
            <div className="err">{groupTitleErr}</div>
          )}
        </Form.Group>
        <Form.Group controlId="gtitle">
          <Form.Label>
            {t(
              "Organizational.Profile.OrganizationalTilte.Place.Holder"
            )}
          </Form.Label>
          {auth.usertype === 1 ? (
            <Select onChange={(e) => console.log(e)}/>
          ) : (
            <Form.Control
              type="text"
              placeholder="مثال : نیما"
              disabled
              defaultValue={form.name}
            />
          )}
        </Form.Group>
        <Form.Group controlId="ghead">
          <Form.Label>
            {t("Organizational.Profile.GroupLeader.Place.Holder")}
          </Form.Label>
          <Select
            options={userTree}
            placeholder={t(
              "Organizational.Profile.GroupLeader.Hint.Place.Holder"
            )}
            onChange={(e) => setGroupHead(e)}
            value={groupHead}
            menuPortalTarget={document.body}
            styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
          />
          {groupHeadErr && <div className="err">{groupHeadErr}</div>}
        </Form.Group>
        <Form.Group controlId="ghead">
          <Form.Label>
            {t(
              "Organizational.Profile.ReferralRestriction.Drop.Search"
            )}
          </Form.Label>
          <Select
            options={automationGroupList}
            isMulti
            placeholder={t(
              "Organizational.Profile.SearchAndSelect"
            )}
            onChange={(e) => setGroupLimit(e || [])}
            value={groupLimit}
            menuPortalTarget={document.body}
            styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
          />
        </Form.Group>

        <Form.Group
          controlId="gmembers"
          style={{gridColumn: "span 2"}}
        >
          <Form.Label>
            {t("Organizational.Profile.GroupMembers.Place.Holder")}
          </Form.Label>
          <Select
            options={userTree}
            isMulti
            placeholder={t(
              "Organizational.Profile.SearchAndSelect"
            )}
            onChange={(e) => setGroupMembers(e || [])}
            value={groupMembers}
            menuPortalTarget={document.body}
            styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
          />
          {groupMembersErr && (
            <div className="err">{groupMembersErr}</div>
          )}
        </Form.Group>
      </form>
      <div className="btn-group superviser-group-actions">
        <button
          type="button"
          className="blue ai-handling-trigger"
          onClick={() => setAiModalShow(true)}
          aria-label={t("ai.handling.button")}
        >
          <MagicStar size={18} aria-hidden="true" />
          <span>{t("ai.handling.button")}</span>
          <AiCoinHint operation="handling_groups" />
        </button>
        <button
          type="button"
          className="blue"
          onClick={createAutomationGroup}
        >
          {createLoader ? (
            <Spinner animation="border" />
          ) : editMode ? (
            <span>
              {t("Organizational.Profile.MakeGroup.Edit.Button")}
            </span>
          ) : (
            <span>
              {t("Organizational.Profile.MakeGroup.Button")}
            </span>
          )}
        </button>
        {editMode ? (
          <button type="button" className="red" onClick={resetForm}>
            {t("Organizational.Profile.Cancel.Button")}
          </button>
        ) : null}
      </div>
      <div className="table-container-profile">
        <table className="user-table">
          <thead>
          <tr className="header-row">
            <th>{t("Organizational.Profile.Row.Label")}</th>
            <th>
              {t("Organizational.Profile.GroupTitle.Label")}
            </th>
            <th>
              {t("Organizational.Profile.GroupLeader.Label")}
            </th>
            <th>{t("Organizational.Profile.Members.Label")}</th>
            <th>
              {t(
                "Organizational.Profile.ReferralRestriction.Label"
              )}
            </th>
            <th>
              {t("Organizational.Profile.Function.Label")}
            </th>
          </tr>
          </thead>
          <tbody>
          {listLoader ? (
            <Spinner animation="border"/>
          ) : (
            automationGroups.results
              ?.sort((a, b) => b.id - a.id)
              .map((item, index) => (
                <Fragment key={index}>
                  <tr className="user-table-row">
                    <td>
                      <div className="level">
                        {index + 1}
                      </div>
                    </td>
                    <td>{item.name}</td>
                    <td className="user">
                      <div></div>
                      <div>
                        <div>
                          {item.head.first_name ||
                          item.head.last_name
                            ? item.head
                              .first_name +
                            " " +
                            item.head
                              .last_name
                            : t(
                              "Organizational.Profile.MakeGroup.Guest.User"
                            )}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        style={{
                          textAlign: "right",
                        }}
                      >
                        {item.members.map(
                          (member) => (
                            <button
                              className="group-user"
                              title={
                                member.first_name ||
                                member.last_name
                                  ? member.first_name +
                                  " " +
                                  member.last_name
                                  : t(
                                    "Organizational.Profile.MakeGroup.Guest.User"
                                  )
                              }
                            >
                              {member.first_name ||
                              member.last_name
                                ? member.first_name +
                                " " +
                                member.last_name
                                : t(
                                  "Organizational.Profile.MakeGroup.Guest.User"
                                )}
                            </button>
                          )
                        )}
                      </div>
                    </td>
                    <td>
                      <div style={{textAlign: "right"}}>
                        {item.assign_groups.length > 0
                          ? item.assign_groups.map(
                            (assignGroup) => (
                              <button className="group-user">
                                {
                                  assignGroup.name
                                }
                              </button>
                            )
                          )
                          : t(
                            "Organizational.Profile.MakeGroup.Unlimited"
                          )}
                      </div>
                    </td>
                    <td className="edit-btns">
                      <button
                        onClick={() =>
                          setModalShow(index)
                        }
                      >
                        {deleteLoader ===
                        item.id ? (
                          <Spinner
                            size="3"
                            animation="border"
                          />
                        ) : (
                          <DeleteIconDark/>
                        )}
                      </button>
                      <button
                        onClick={() =>
                          goToEditMode(item)
                        }
                      >
                        <EditIonDark/>
                      </button>
                    </td>
                  </tr>
                  <ConfirmModal
                    show={modalShow === index}
                    onHide={() => setModalShow(false)}
                    onConfirm={() => {
                      deleteAutomationGroup(item.id);
                      setModalShow(false);
                    }}
                    title={t(
                      "Organizational.Profile.MakeGroup.Remove.Group"
                    )}
                    description={`${t(
                      "Organizational.Profile.MakeGroup.Remove.Group.PartOne"
                    )} ${item.name} ${t(
                      "Organizational.Profile.MakeGroup.Remove.Group.PartTwo"
                    )}`}
                    btnTitle={t(
                      "Organizational.Profile.MakeGroup.Remove"
                    )}
                  />
                </Fragment>
              ))
          )}
          </tbody>
        </table>
      </div>
      <AIHandlingGroupModal
        showModal={aiModalShow}
        companyId={getCompanyId()}
        onHide={() => setAiModalShow(false)}
        onSuccess={() => {
          const companyId = getCompanyId();
          getAutomationGroups(false);
          getAutomationGroupList(companyId);
        }}
      />
    </div>
  );
}
